import React from "react";
import { Star } from "lucide-react";
import { cn } from "@/lib/format";

export default function RatingStars({ value = 0, onChange, size = 32, readOnly = false }) {
  const [hover, setHover] = React.useState(0);
  return (
    <div className="flex items-center gap-1.5">
      {[1, 2, 3, 4, 5].map((s) => {
        const active = (hover || value) >= s;
        return (
          <button
            key={s}
            type="button"
            disabled={readOnly}
            data-testid={`star-${s}`}
            onMouseEnter={() => !readOnly && setHover(s)}
            onMouseLeave={() => !readOnly && setHover(0)}
            onClick={() => !readOnly && onChange?.(s)}
            className={cn("transition-transform", !readOnly && "hover:scale-110")}
          >
            <Star
              style={{ width: size, height: size }}
              className={active ? "fill-amber-400 text-amber-400" : "text-border"}
            />
          </button>
        );
      })}
    </div>
  );
}
